import React from "react";
import styles from "./NotFoundPage.module.css";

function NotFoundPage() {
  return (
    <div className={styles.NotFound}>
      <span>404</span>
      <h1>Page not found</h1>
      <p>The page may have moved, but the rest of the VoiceTyping library is still here.</p>
      <a href="/">Back to the blog</a>
    </div>
  );
}

export default NotFoundPage;
